import ManagementCompany from './FundsManagementCompany';
export default ManagementCompany;